<div class="gridParent">
  <input id="showDetailGrid" type="hidden" [value]="gridSettings.showSubGrid" />

  <ng-template #gridTooltip let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
  </ng-template>

  <div kendoTooltip showOn="none" [tooltipTemplate]="gridTooltip" filter=".k-grid td" (mouseover)="showTooltip($event)">
    <kendo-grid gridDataBinding kendoGridExpandGroupBy #searchGrid
                [id]="gridSettings.gridName"
                [resizable]="true"
                [sortable]="true"
                [reorderable]="true"
                [filterable]="false"
                [filter]="filter"
                [rowClass]="defaultRowCallback"
                [pageable]="pagerSettings"
                [pageSize]="pageSize"
                (dataStateChange)="dataStateChange($event)"
                [groupable]="false"
                [group]="state.group ?? []"
                [groupsInitiallyExpanded]="false"
                [(expandedGroupKeys)]="expandedGroupKeys"
                [selectable]="selectableSettings"
                [rowSelected]="isRowSelected"
                (cellClick)="onCellClicked($event)"
                (dblclick)="defaultDoubleClick($event)"
                (columnVisibilityChange)="columnVisibilityChange($event)"
                (columnReorder)="onColumnReorder($event)"
                (selectionChange)="selectRow($event)"
                kendoGridFocusable
                [navigable]="true"
                [columnMenu]="true"
                style="height:42vw;width:100%;">

      <!--Still fine tuning this-->
      <!--<ng-template kendoGridColumnMenuTemplate let-service="service" let-column="column" let-context="context">
        <kendo-grid-columnmenu-sort [service]="service"></kendo-grid-columnmenu-sort>
        <kendo-grid-columnmenu-chooser [service]="service"></kendo-grid-columnmenu-chooser>
        <kendo-grid-columnmenu-filter [service]="service"></kendo-grid-columnmenu-filter>

        <app-filter-column-values class="k-columnmenu-item-wrapper"
                                  [service]="service"
                                  [column]="column"
                                  [data]="columnValues[column.field]"
                                  [filter]="compositeFilter.orFilter"
                                  (valuesChange)="onColumnValueGetValuesChange($event)"
                                  (filterChange)="onColumnValueFilterChange()"
                                  [newSearch]="newSearch"></app-filter-column-values>

      </ng-template>-->

      @if (!gridSettings.hideSelectAll) {
      <kendo-grid-checkbox-column [showSelectAll]="true" [width]="45"></kendo-grid-checkbox-column>
      }
      @for (column of colSettings; track column.field) {
      <kendo-grid-column field="{{column.field}}"
                         title="{{column.title}}"
                         format="{{column.format | gridCellFormat: column.field}}"
                         [filter]="column.type"
                         [width]="column.width"
                         [hidden]="column.hidden"
                         [editable]="column.editable"
                         [editor]="column.editor">
        <ng-template kendoGridGroupHeaderTemplate let-group let-value="value" let-field="field">
          {{ getColumnTitle(field) | translate }}: {{ value }} ({{ getGroupItemCount(group) }})
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter="filter" let-col="column">
          @if (col.filter == 'text') {
          <kendo-grid-string-filter-cell [column]="col" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
            <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
          </kendo-grid-string-filter-cell>
          } @else if (col.filter == 'numeric') {
          <kendo-grid-numeric-filter-cell [column]="col" [filter]="filter" [format]="column.filterFormat ?? 'n2'">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
          </kendo-grid-numeric-filter-cell>
          } @else if (col.filter == 'boolean') {
          <kendo-grid-boolean-filter-cell [column]="col" [filter]="filter">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
          </kendo-grid-boolean-filter-cell>
          } @else if (col.filter == 'date') {
          <kendo-grid-date-filter-cell [column]="col" [filter]="filter" operator="eq">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
          </kendo-grid-date-filter-cell>
          }
        </ng-template>
        @if (column.type === 'boolean') {
        <ng-template kendoGridCellTemplate let-dataItem>
          <input type="checkbox" kendoCheckBox [checked]="dataItem[column.field]" onclick="return false;" />
        </ng-template>
        }
        @if (column.hasActions && column.actions != undefined && column.actions.length > 0) {
        <ng-template kendoGridCellTemplate let-dataItem>
          @for (action of column.actions; track action) {
          <button kendoButton class="{{action.cssClass}}"
                  (click)="action?.action(dataItem)">
            {{ action.text }}
          </button>
          }
        </ng-template>
        }
        @if (column.aggregate != undefined) {
        <ng-template kendoGridFooterTemplate>
          <span>{{ column.field | gridAggregate: (grid ? grid.data : []): aggregates }}</span>
        </ng-template>
        }
      </kendo-grid-column>
      }
      @if (gridSettings.showSubGrid) {
      <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showDetailGrid">
        <div>
          <app-grid-detail [columns]="gridSettings.subGridColumns" [dataItem]="dataItem" [dataProperty]="gridSettings.subGridDataProperty"></app-grid-detail>
        </div>
      </ng-template>
      }
      <kendo-grid-excel [fileName]="exportFilename" [fetchData]="fetchAllData">
      </kendo-grid-excel>
    </kendo-grid>
  </div>
  <kendo-contextmenu #gridMenu
                     [kendoMenuHierarchyBinding]="gridSettings.contextMenuItems ?? []"
                     [textField]="'title'"
                     childrenField="items"
                     svgIconField="iconClass"
                     separatorField="separator"
                     (select)="onContextMenuSelect($event)"></kendo-contextmenu>

  <div id="loading">
    <span>Loading Data... <span class="loadingTimer">{{ ElapsedTime() }}</span></span>
  </div>
</div>


